import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { DialogContent, DialogContentText } from "@material-ui/core";
import PersonAddForm from "../Person/Add/PersonAddForm";

const UserAddModal = (props) => {
  const { handleClose } = props;

  return (
    <Wrapper>
      <DialogContent>
        <DialogContentText>
          <PersonAddForm isModal={true} handleClose={handleClose} />
        </DialogContentText>
      </DialogContent>
    </Wrapper>
  );
};

export default UserAddModal;
